namespace Solovis.Reports.Parts.Tables.DataTableHelpers {

    /*
     * FloatingColumnHeader manages position of the floating headers.     
     */
    export class FloatingColumnHeader {

        public _standardTableRenderer;
        public tableControl;
        public _tableContainer;
        public _columnsGetter;
        public _trueTableGetter;
        public _floatingColumnHeaderDiv: JQuery;
        public _headerTable: JQuery;
        public _handlePositionUpdateCallback;
        public _scrollables;        


        constructor(options) {
            var self = this;

            this._standardTableRenderer = options.standardTableRenderer;
            this.tableControl = options.tableControl;
            this._tableContainer = options.tableContainer;
            this._columnsGetter = options.columnsGetter;
            this._trueTableGetter = options.trueTableGetter;

            var floatingColumnHeaderDiv = options.floatingColumnHeaderDiv;
            this._floatingColumnHeaderDiv = floatingColumnHeaderDiv;

            floatingColumnHeaderDiv.css("position", "absolute");
            floatingColumnHeaderDiv.css("left", "0px");
            floatingColumnHeaderDiv.css("z-index", "1");

            this._headerTable = $("<table>").addClass("report-data-table")
                .css("table-layout", "fixed")
                .appendTo(floatingColumnHeaderDiv);

            (this._headerTable.get(0) as any).__floatingColumnHeaderTrueTableGetter = this._trueTableGetter;

            this._handlePositionUpdateCallback = function () {
                self._updateFloatingHeaderPosition();
            };

            this._scrollables = Solovis.UI.DomHelper.getVerticalScrollableContainers(this.tableControl.controlHost.container);

            $(this._scrollables).each(function (i, scrollable) {
                scrollable.addEventListener("scroll", self._handlePositionUpdateCallback);
            });
            $(window).bind("resize", this._handlePositionUpdateCallback);
        }


        public _unregisterFromScrollResizeEvents() {
            var self = this;

            $(this._scrollables).each(function (i, scrollable) {
                scrollable.removeEventListener("scroll", self._handlePositionUpdateCallback);
            });

            $(window).unbind("resize", this._handlePositionUpdateCallback);
        }

        public _updateFloatingHeaderPosition() {
            if (!Solovis.UI.DomHelper.isDescendantOf(this._tableContainer, document.body)) {
                // This table is no longer part of the document.            
                this._unregisterFromScrollResizeEvents();
                return;
            }

            let firstScrollable = this._scrollables[0];

            let windowScrollTop = $(window).scrollTop();

            if (Solovis.UX.Utils.isNewUxEnabled()) {
                // Note: Modern headers is sticky and 48px tall 
                windowScrollTop += 48;
            }

            if (window !== firstScrollable) {               
                let firstScrollableTop = $(firstScrollable).offset().top;

                // Even if table is inside of another scrollbable container, that scrollable container might
                // be off the top of the page, so we still need to limit based on window if applicable.
                windowScrollTop = Math.max(firstScrollableTop, windowScrollTop);
            }

            var tableTop = $(this._tableContainer).offset().top;

            if (tableTop > windowScrollTop) {
                this._floatingColumnHeaderDiv.css("display", "none");
            }
            else {
                var floatingHeaderOffsetY = windowScrollTop - tableTop;

                var trueTable = this._trueTableGetter();
                if (trueTable) {
                    var tableHeight = $(trueTable).outerHeight();
                    var headerHeight = $(this._headerTable).outerHeight();
                    if ((floatingHeaderOffsetY + headerHeight) > tableHeight) {
                        floatingHeaderOffsetY = Math.max(0, tableHeight - headerHeight);
                    }
                }

                this._floatingColumnHeaderDiv.css("top", "" + floatingHeaderOffsetY + "px");

                this._floatingColumnHeaderDiv.css("display", "block");
            }
        }

        public updateFloatingHeaderContent(updatePositionToo?) {
            if (updatePositionToo) {
                this._updateFloatingHeaderPosition();
            }

            var columns = this._columnsGetter();

            var columnsCopy = Solovis.deepCopy(columns);

            var trueTable = this._trueTableGetter();
            if (trueTable) {
                var trueTableColList = trueTable.children("colgroup").children("col");

                var totalWidth = 0;
                $(columnsCopy).each(function (i, colCopy: any) {
                    var trueColStyle = $(trueTableColList.get(i));

                    colCopy.width = parseInt(trueColStyle.css("width"));
                    totalWidth += colCopy.width;
                });

                this._headerTable.html("");
                this._headerTable.css("width", totalWidth);
                this._floatingColumnHeaderDiv.css("width", totalWidth);

                Solovis.Reports.Parts.Tables.DataTableHelpers.StandardTableRenderer.appendHeaderRows(this._headerTable, columnsCopy, this.tableControl);
            }
        };
    }

}
